import { Routes, Route } from "react-router-dom";
import EngagePlanAdmin from "./components/Masterpanel/EngagePlanAdmin/List";
import { AuthProvider } from "./hooks/useEngageV1Auth";

const EngageRoutes = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="admin" element={<EngagePlanAdmin />} />
      </Routes>
    </AuthProvider>
  );
};

export default EngageRoutes;